export default "__VITE_ASSET__B$sYGDk6__"